// Helper function to get or create client ID cookie
// This is used for tracking/analytics (e.g., GrowthBook)
export function getClientId() {
  if (typeof document === "undefined") return null;

  const cookieName = "client_id";
  const match = document.cookie.match(
    new RegExp("(^| )" + cookieName + "=([^;]+)"),
  );

  if (match) {
    return match[2];
  }

  // Generate new client ID
  const newClientId =
    "client_" +
    Math.random().toString(36).substring(2) +
    Date.now().toString(36);

  // Set cookie for 1 year
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  document.cookie = `${cookieName}=${newClientId};expires=${expires.toUTCString()};path=/;SameSite=Lax`;

  return newClientId;
}
